module.exports = __webpack_public_path__ + "static/makook-service-technique-comedic-series-b1605cabdc32c4ede7c12020f3ec9412.mp4";